import Vue from "vue";
// Firebase and the modules to be used.
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

export default {
  state: {
    userEmail: {}
  },
  mutations: {
    setUserEmail(state, payload) {
      state.userEmail = payload;
    }
  },
  actions: {
    addedToBasket({commit},payload){
    },
    saveEmail({commit}, payload) {
      commit('setLoading', true);
      commit('clearError');

      let currentdate = new Date();
      const email = {
        email: payload.email,
        locale: navigator.language,
        timestamp: currentdate.getDate() + "/"
          + (currentdate.getMonth() + 1) + "/"
          + currentdate.getFullYear() + " @ "
          + currentdate.getHours() + ":"
          + currentdate.getMinutes() + ":"
          + currentdate.getSeconds()
      };

      firebase.firestore().collection('analysis').doc(payload.restaurantId).collection('clientEmails').doc(payload.email).set(email)
        .then(() => {
          commit('setUserEmail', email);
          commit('setLoading', false);
          console.log("Email saved !");
        }).catch((error) => {
        commit('setLoading', false);
        commit('setError', error);
        console.error("Error saving email: ", error);
      });
    }
  },
  getters: {}
}



// WEBPACK FOOTER //
// ./src/store/simpleMenu/index.js